"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePromoCodeFromCart = void 0;
const utils_1 = require("../../../utils");
const buildPath = (cartId, promoCode) => `/v1/bff/appro/carts/${cartId}/promo-codes/${promoCode}`;
const removePromoCodeFromCart = (client) => async ({ cartId, promoCode }) => {
    try {
        const { data } = await client.delete(buildPath(cartId, promoCode));
        return { cart: data };
    }
    catch (error) {
        if ((0, utils_1.isFunctionalApiError)(error)) {
            return {
                error: {
                    code: error.body.code,
                    message: error.body.message
                }
            };
        }
        throw error;
    }
};
exports.removePromoCodeFromCart = removePromoCodeFromCart;
